<template>
  <div :class="getAttributeBarUnderline()" @wheel="onWheel" @scroll="onHorizontalScroll">
    <div
      class="category-item"
      v-for="(topCategory, topCategoryKey) in topCategories"
      :class="getTopCategoryContainerStyle(topCategory, selectedCategory)"
      :key="topCategoryKey"
    >
      <!--  Collapsed -->
      <div
        v-if="
          !(
            topCategory.subCategoryKeys.includes(selectedCategory) &&
            topCategory.subCategoryKeys.length > 1
          )
        "
        @click="setCategory(topCategory.subCategoryKeys[0])"
        :class="getBottomBarStyle(topCategory, selectedCategory)"
        tabindex="0"
        @keyup.enter="setCategory(topCategory.subCategoryKeys[0])"
      >
        <span v-html="getIcon(topCategory.iconName || topCategory.subCategoryKeys[0])" />
        <transition name="badge-clear">
          <span
            v-if="hasPromotedSubCategories(topCategory.subCategoryKeys)"
            :class="[showGradient ? 'badge-dot-underline' : 'badge-dot']"
          />
        </transition>
      </div>

      <!-- Expanded -->
      <div
        v-else
        v-for="subcategory in topCategory.subCategoryKeys"
        :key="subcategory"
        :class="getSubcategoryBottomBarStyle(subcategory, selectedCategory)"
        @click="setCategory(subcategory)"
        tabindex="0"
        @keyup.enter="setCategory(subcategory)"
      >
        <span v-html="getIcon(subcategory)" />
        <transition name="badge-clear">
          <span
            v-if="promotedCategories.includes(subcategory)"
            :class="[showGradient ? 'badge-dot-underline' : 'badge-dot']"
          />
        </transition>
      </div>
    </div>
    <div v-if="!isIOS12" id="marker" :class="{ isMakeupDarkMode: isMakeup }" />
    <div :class="bottomBarLeftStyle" />
    <div :class="bottomBarRightStyle" />
  </div>
</template>
<script>
import Icons from '@/assets/bottom_bar_icons.json';
import { OUTFIT_CATEGORY_KEY } from '@/constants';
import { GenderEnum } from '@/enum/gender';
import DetailedOutfitHelper from '@/services/DetailedOutfitHelper';

export default {
  name: 'Bottombar',
  components: {},
  props: [
    'isMakeup', //: Boolean
    'showGradient', //: Boolean
  ],

  data: function() {
    return {
      atScrollEndLeft: true,
      atScrollEndRight: false,
      prevAtScrollEnd: false,
      prevSelectedCategory: null,
    };
  },

  mounted: function() {
    this.scrollToActiveCategory(true);
    this.$store.commit('logPageView');
  },
  computed: {
    isIOS12() {
      return this.$store.getters.isIOS12;
    },
    topCategories() {
      return this.$store.getters.categoryList;
    },
    selectedCategory() {
      return this.$store.getters.selectedCategory;
    },
    promotedCategories() {
      return this.$store.getters.promotedCategories;
    },
    bottomBarLeftStyle() {
      if (!this.showGradient || this.isIOS12) {
        return '';
      }
      if (this.atScrollEndLeft) {
        return ['position-gradient', 'left-gradient'];
      } else {
        return ['position-gradient', 'left-gradient', 'not-scroll-end'];
      }
    },
    bottomBarRightStyle() {
      if (!this.showGradient || this.isIOS12) {
        return '';
      }
      if (this.atScrollEndRight) {
        return ['position-gradient', 'right-gradient'];
      } else {
        return ['position-gradient', 'right-gradient', 'not-scroll-end'];
      }
    },
  },
  watch: {
    selectedCategory: function(newSelectedCategory, prevSelectedCategory) {
      this.promotedCategories.includes(prevSelectedCategory) &&
        this.$store.commit('clearStaleCategoryPromotion', prevSelectedCategory);
      this.$store.commit('logPageView');
    },
  },
  methods: {
    moveUnderline() {
      if (!this.showGradient || this.isIOS12) {
        return;
      }
      const rect = this.$el
        .querySelector('.bottombar-icon-underline.active')
        .getBoundingClientRect();
      var marker = document.querySelector('#marker');
      marker.style.transition = '0.3s';
      marker.style.left = `${rect.x - 8}px`;
      marker.style.width = `${rect.width + 15}px`;
    },
    setUnderline() {
      if (!this.showGradient || this.isIOS12) {
        return;
      }
      const rect = this.$el
        .querySelector('.bottombar-icon-underline.active')
        .getBoundingClientRect();
      var marker = document.querySelector('#marker');
      marker.style.transition = '0s';
      marker.style.left = `${rect.x - 8}px`;
      marker.style.width = `${rect.width + 15}px`;
    },
    getAttributeBarUnderline() {
      return {
        isMakeupDarkMode: this.isMakeup,
        'category-bottombar-underline': this.showGradient,
        'category-bottombar': true,
      };
    },
    getTopCategoryContainerStyle(topCategory, selectedCategory) {
      return {
        active: topCategory.subCategoryKeys.includes(selectedCategory),
        'has-subCategories': topCategory.subCategoryKeys.length > 1,
        isMakeupDarkMode: this.isMakeup,
        'top-category-container-underline': this.showGradient,
        'top-category-container': !this.showGradient,
      };
    },
    getBottomBarStyle(topCategory, selectedCategory) {
      return {
        active: topCategory.subCategoryKeys.includes(selectedCategory),
        isMakeupDarkMode: this.isMakeup,
        'bottombar-icon-underline': this.showGradient,
        'bottombar-icon': !this.showGradient,
      };
    },
    getSubcategoryBottomBarStyle(subcategory, selectedCategory) {
      return {
        active: subcategory === selectedCategory,
        isMakeupDarkMode: this.isMakeup,
        subcategory: true,
        'bottombar-icon-underline': this.showGradient,
        'bottombar-icon': !this.showGradient,
      };
    },
    hasPromotedSubCategories(subCategoryKeys) {
      return subCategoryKeys.reduce(
        (prev, curr) => prev || this.promotedCategories.includes(curr),
        false,
      );
    },
    setCategory(categoryKey) {
      this.$store.commit('scrollToPageWithCategoryKey', { categoryKey });
    },
    getIcon(categoryKey) {
      // Different icons based on male or female
      const isMale = this.$store.getters.gender === GenderEnum.MALE;

      switch (categoryKey) {
        case 'beard':
          return Icons.avbuilder_beard;
        case 'beard_tone':
          return Icons.avbuilder_colorprimary;
        case 'blush_tone':
          return Icons.avbuilder_makeup_blush;
        case 'body':
          return Icons.avbuilder_bodytype;
        case 'bottombar_facialdetails':
          return Icons.avbuilder_facialdetails;
        case 'bottombar_hair_female':
          return Icons.avbuilder_hair_female;
        case 'bottombar_hair_male':
          return Icons.avbuilder_hair_male;
        case 'bottom':
          return Icons.avbuilder_fashion_bottoms;
        case 'breast':
          return Icons.avbuilder_chestsize;
        case 'brow':
          return Icons.avbuilder_eyebrow;
        case 'brow_tone':
          return Icons.avbuilder_colorprimary;
        case 'cheek_details':
          return Icons.avbuilder_face_cheeklines;
        case 'ear':
          return Icons.avbuilder_ears;
        case 'earring':
        case 'earring_dual':
          return Icons.avbuilder_piercings;
        // Since we swap the left/right earring labels in UI, swap the icons as well
        case 'earring_left':
          return Icons.avbuilder_right_piercings;
        case 'nosering':
          return Icons.avbuilder_nose_piercings;
        case 'earring_right':
          return Icons.avbuilder_left_piercings;
        case 'browring_left':
          return Icons.avbuilder_right_eyebrow_piercings;
        case 'browring_right':
          return Icons.avbuilder_left_eyebrow_piercings;
        case 'earaid_left':
          return Icons.avbuilder_right_hearingdevice;
        case 'earaid_right':
          return Icons.avbuilder_left_hearingdevice;
        case 'mouthring':
          return Icons.avbuilder_mouth_piercing;
        case 'tonguering':
          return Icons.avbuilder_tongue_piercing;
        case 'eye':
          return Icons.avbuilder_eyes;
        case 'eye_details':
          return Icons.avbuilder_face_eyelines;
        case 'eye_size':
          return Icons.avbuilder_eye_size;
        case 'eye_spacing':
          return Icons.avbuilder_eyes_spacing;
        case 'eyelash':
          return Icons.avbuilder_eyelashes;
        case 'eyeshadow_tone':
          return Icons.avbuilder_makeup_eyeshadow;
        case 'face_lines':
          return Icons.avbuilder_face_foreheadlines;
        case 'face_proportion':
          return Icons.avbuilder_faceshape;
        case 'glasses':
          return Icons.avbuilder_eyeglasses;
        case 'hair':
          return isMale ? Icons.avbuilder_hair_male : Icons.avbuilder_hair_female;
        case 'hair_tone':
          return Icons.avbuilder_colorprimary;
        case 'hair_treatment_tone':
          return Icons.avbuilder_colorsecondary;
        case 'hat':
          return Icons.avbuilder_fashion_headwear;
        case 'jaw':
          return Icons.avbuilder_jaw;
        case 'lipstick_tone':
          return Icons.avbuilder_makeup_lipstick;
        case 'mouth':
          return isMale ? Icons.avbuilder_lips_male : Icons.avbuilder_lips_female;
        case 'nose':
          return Icons.avbuilder_nose;
        case 'outfit':
          return Icons.avbuilder_fashion_outfits;
        case 'outerwear':
          return Icons.avbuilder_fashion_outerwear;
        case 'pupil':
          return Icons.avbuilder_iris_size;
        case 'pupil_tone':
          return Icons.avbuilder_colorprimary;
        case 'save':
          return Icons.avbuilder_save;
        case 'top':
          return Icons.avbuilder_fashion_tops;
        case 'footwear':
          return Icons.avbuilder_fashion_footwear;
        case 'sock':
          return Icons.avbuilder_fashion_socks;
        case 'skin_tone':
          return Icons.avbuilder_skin;
        case 'style':
          return Icons.avbuilder_style;
        case 'my_closet':
          return Icons.avbuilder_fashion_closet;
        case 'one_piece':
          return Icons.avbuilder_fashion_dresses;
        default:
          return Icons.avbuilder_skin;
      }
    },
    scrollToActiveCategory(onMounted) {
      const activeCategoryIconClass = this.showGradient
        ? '.bottombar-icon-underline.active'
        : '.bottombar-icon.active';
      const el = this.$el.querySelector(activeCategoryIconClass);

      // If the OUTFIT_CATEGORY_KEY icon or any other mix-and-match category is being selected,
      // push all the icons as far as you can so that the mix and match categories are
      // visible. https://jira.sc-corp.net/browse/BM-8777
      if (
        onMounted &&
        (this.selectedCategory === OUTFIT_CATEGORY_KEY ||
          DetailedOutfitHelper.DETAILED_OUTFIT_KEYS.includes(this.selectedCategory))
      ) {
        const bottomBarIcons = this.showGradient
          ? this.$el.querySelectorAll('.bottombar-icon-underline')
          : this.$el.querySelectorAll('.bottombar-icon');
        const saveIcon = bottomBarIcons[bottomBarIcons.length - 1];
        saveIcon.scrollIntoView(true);
        // For smaller screen, if the outfit icon is being pushed off the screen, scroll it back
        // TODO(kcharoenphiphob): check on this once more mix and match categories have been added
        if (el.getBoundingClientRect().left < 0) {
          el.scrollIntoView(true);
        }
      } else if (this.$store.getters.centerActiveCategoryIcon) {
        const iconOffset = el.offsetLeft;
        const iconWidth = el.clientWidth;
        const bottomBarClass = this.showGradient
          ? '.category-bottombar-underline'
          : '.category-bottombar';
        const bottomBarEl = document.querySelector(bottomBarClass);
        const clientWidth = bottomBarEl.clientWidth;
        bottomBarEl.scrollLeft = iconOffset - clientWidth / 2 + iconWidth / 2;
        this.$store.commit('categoryIconCentered');
      } else {
        el.scrollIntoView(true);
      }
      this.moveUnderline();
      this.prevSelectedCategory = this.$store.getters.selectedCategory;
    },
    onHorizontalScroll({ target: { scrollLeft, clientWidth, scrollWidth } }) {
      this.prevAtScrollEnd = this.atScrollEndLeft || this.atScrollEndRight;
      this.atScrollEndLeft = scrollLeft <= 0;
      this.atScrollEndRight = scrollLeft + clientWidth >= scrollWidth;
      this.setUnderline();
    },
    onWheel(event) {
      // Translate vertical mouse scrolls to horizontal scrolls in the bar
      this.$el.scrollLeft += event.deltaY;
    },
  },
  updated: function() {
    // Avoids unecessary execution when scrolling at either end of the attribute bar & handles category grid horizontal scrolling
    if (
      !(this.atScrollEndRight || this.atScrollEndLeft || this.prevAtScrollEnd) ||
      this.$store.getters.selectedCategory != this.prevSelectedCategory
    ) {
      this.scrollToActiveCategory(false);
    }
  },
};
</script>

<style scoped>
.category-bottombar {
  overflow-x: auto;
  /*TODO: Remove iOS horizontal scrollbar that appears */
  -webkit-overflow-scrolling: touch; /*Momentum scrolling*/
  width: auto;
  white-space: nowrap;
  padding: 0 4px;
  scrollbar-width: thin; /* firefox */
}

.category-bottombar-underline {
  overflow-x: auto;
  overflow-y: hidden;
  /*TODO: Remove iOS horizontal scrollbar that appears */
  -webkit-overflow-scrolling: touch; /*Momentum scrolling*/
  width: auto;
  white-space: nowrap;
  padding: 0 4px;
  scrollbar-width: thin; /* firefox */
  border-bottom: 0.5px solid rgb(230, 230, 230);
}

.category-bottombar-underline.isMakeupDarkMode {
  border-bottom: 1px solid rgb(40, 40, 40);
}

.top-category-container,
.top-category-container-underline {
  display: inline-block;
  width: auto;
  white-space: nowrap;
  vertical-align: center;
}

.active.top-category-container {
  border-radius: 30px;
}

.active.top-category-container-underline {
  border-radius: 20px 20px 1.5px 1.5px;
}

.active.has-subCategories.top-category-container {
  background: #eeeeee;
  height: 35px;
  margin: 5px 8px;
  padding-left: 6px;
  padding-right: 6px;
}

.active.has-subCategories.top-category-container-underline {
  background: #eeeeee;
  padding: 5px 0 0 0;
}

.active.has-subCategories.top-category-container.isMakeupDarkMode,
.active.has-subCategories.top-category-container-underline.isMakeupDarkMode {
  background: #1f1f1f;
}

.active.bottombar-icon {
  fill: #0a92ff;
}

.active.bottombar-icon-underline {
  fill: #1f1f1f;
}

.active.subcategory.bottombar-icon {
  fill: #0a92ff;
}

.active.subcategory.bottombar-icon-underline {
  fill: #1f1f1f;
}

.active.subcategory.bottombar-icon-underline.isMakeupDarkMode {
  fill: #ffffff;
}

.active-underline,
.active-subcategory-underline {
  background-color: #1f1f1f;
  width: 45px;
  height: 3px;
  border-radius: 150px;
  z-index: 1;
  position: absolute;
  top: 36px;
  right: -6px;
}

.active-subcategory-underline.isMakeupDarkMode {
  background-color: white;
}

.active-subcategory-underline {
  top: 37px;
}

.bottombar-icon {
  cursor: pointer;
  display: inline-block;
  margin: 11px 8px;
  width: 33px;
  height: 33px;
  fill: #88909a;
  position: relative;
}

.bottombar-icon-underline {
  cursor: pointer;
  display: inline-block;
  margin: 8px 10px 0 10px;
  width: 33px;
  fill: #88909a;
  position: relative;
}

.subcategory.bottombar-icon {
  display: inline-block;
  margin: 1px 6px;
  width: 33px;
  height: 33px;
}

.subcategory.bottombar-icon-underline {
  display: inline-block;
  margin: 1px 8px;
  fill: #88909a;
}

.badge-dot {
  height: 5px;
  width: 5px;
  background-color: #0a92ff;
  border-radius: 50%;
  position: absolute;
  bottom: -5px;
  left: calc(50% - 2.5px);
}

.badge-dot-underline {
  height: 5px;
  width: 5px;
  background-color: #0a92ff;
  border-radius: 50%;
  position: absolute;
  bottom: 0px;
  left: calc(50% - 2.5px);
}

.badge-clear-leave-active {
  transition: opacity 0.5s, bottom 0.5s;
}

.badge-clear-leave-to {
  opacity: 0;
  bottom: -10px;
}

.position-gradient {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.5s linear;
}

.left-gradient {
  background: var(--left-gradient);
  z-index: 1;
}

.right-gradient {
  background: var(--right-gradient);
  z-index: 1;
}

.not-scroll-end {
  opacity: 1;
  transition: opacity 0.5s linear;
}

#marker {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 3px;
  width: 0;
  background-color: #1f1f1f;
  transition: 0.5s;
  border-radius: 150px;
  z-index: 1;
}

#marker.isMakeupDarkMode {
  background-color: white;
}

@media (hover: hover) {
  .category-bottombar::-webkit-scrollbar {
    display: block;
    height: 6px;
  }
  :hover::-webkit-scrollbar-thumb {
    background: rgba(167, 167, 167, 0.19);
  }
}

@media (prefers-color-scheme: dark) {
  .category-bottombar-underline {
    border-bottom: 1px solid rgb(40, 40, 40);
  }

  .active.has-subCategories.top-category-container,
  .active.has-subCategories.top-category-container-underline {
    background: #1f1f1f;
  }

  .active.bottombar-icon-underline {
    fill: #ffffff;
  }

  .active.subcategory.bottombar-icon-underline {
    fill: #ffffff;
  }

  .active-underline,
  .active-subcategory-underline {
    background-color: white;
  }

  .active-subcategory-underline {
    top: 36px;
  }

  .left-gradient {
    background: var(--left-dark-gradient);
  }

  .right-gradient {
    background: var(--right-dark-gradient);
  }

  #marker {
    background-color: white;
  }
}
</style>
